import { Component, OnInit } from '@angular/core';
import { Configuration } from '@shared/models/configuration';
import { CreateWorkflowAction } from '../../../workflow/store/workflow.actions';
import { select, Store } from '@ngrx/store';
import { IWorkflowCollectionState } from '../../../workflow/store/workflow.reducer';
import {
  getWorkflow,
  getWorkflowCurrentState,
  getWorkflowCurrentStateIndex, getWorkflowStates,
  isWorkflowCleanedUp
} from '../../../workflow/store/workflow.selector';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import { Guid } from 'guid-typescript';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {WorkflowModel, WorkflowState} from '../../../workflow/models/workflow.model';

@Component({
    standalone: false,
    selector: 'particle-filing-manager-form-workflow',
  templateUrl: './filing-manager-form-workflow.component.html',
  styleUrls: ['./filing-manager-form-workflow.component.scss']
})
export class FilingManagerFormWorkflowComponent implements OnInit {
  workflowId: string;
  apiEndpointKey: string;
  workflowTemplateId: string;
  cleanedUp$: any;
  unsubscribe$ = new Subject<void>();
  private formTemplateId: string;
  private arrangementId: string;
  private arrangementGuid: string;
  private sourceType: string;
  tabs: any[];
  private formId: string;
  private workflow$: Observable<WorkflowModel>;

  constructor(protected activatedRoute: ActivatedRoute, private store: Store<IWorkflowCollectionState>, private router: Router, private route: ActivatedRoute) {
    this.workflowId = Guid.create().toString();
    this.workflowTemplateId = 'filing-manager-form-ui-workflow';
    this.formTemplateId = '';
    this.apiEndpointKey = 'Dac6Api';
    this.tabs = [
      {
        id: 0,
        header: 'Monthly Filing',
        index: 0,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6MonthlyFiling',
        filingType: 'monthly',
        relativeUrl: 'dac6-reporter/filing/monthly'
      },
      {
        id: 1,
        header: 'Quarterly Filing',
        index: 1,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6QuarterlyFiling',
        filingType: 'quarterly',
        relativeUrl: 'dac6-reporter/filing/quarterly'
      },
      {
        id: 2,
        header: 'Annual Filing',
        index: 2,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6YearlyFiling',
        filingType: 'annual',
        relativeUrl: 'dac6-reporter/filing/annual'
      },
      {
        id: 3,
        header: 'Other Filing',
        index: 3,
        invalidateSubject: new InvalidateSubject(),
        sourceKey : 'Dac6OtherFiling',
        filingType: 'other',
        relativeUrl: 'dac6-reporter/filing/other'
      }
    ];
  }

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      if (params) {
        this.formTemplateId = params.formTemplateId;
        this.arrangementId = params.arrangementId;
      }
    });

    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(queryParams => {
      if ( queryParams.arrangementGuid ) {
        this.arrangementGuid = queryParams.arrangementGuid;
      }
      if ( queryParams.sourceType ) {
        this.sourceType = queryParams.sourceType;
      }
    });
    const url = `${Configuration.getConfig( this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'filing manager form ui workflow', this.workflowTemplateId, false);
    // const currentDate = new Date();
    action.setParameters({
      'FORM_TEMPLATE_ID': this.formTemplateId,
      'Arrangement_Id': this.arrangementId,
      'ARRANGEMENT_GUID': this.arrangementGuid
    });
    this.store.dispatch(action);

    this.workflow$ = this.store.pipe(select(getWorkflow, this.workflowId));
    this.workflow$.pipe(takeUntil(this.unsubscribe$)).subscribe(workflow => {
      if (workflow) {
        console.log('workflow$', workflow);
        if (workflow.States[0].Arguments && workflow.States[0].Arguments['FormId']){
          this.formId = workflow.States[0].Arguments['FormId'];
        }
      }
    });
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state === 'Finished' && this.formId) {
        this.router.navigateByUrl(`dac6-reporter/filing-manager/forms/${this.formId}`);
        return;
      }
      if (state === 'Finished' || state === 'Cancelled') {
        const filingType = this.tabs.find( d => d.sourceKey === this.sourceType ).filingType;
        this.router.navigateByUrl(`dac6-reporter/filing/` + filingType);
      }
    });
  }

}
